


















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ListingDetail } from '@/models/ListingDetail';
import { RequestViewingViewModel } from '@/models/RequestViewingViewModel';

@Component
export default class BookViewingDialog extends Vue {

    public showDialog: boolean = false;
    public requestSubmittedSuccessfully: boolean = false;
    public widthThresholdValue: number = 768;
    public heightThresholdValue: number = 415;
    public isWorkingWithAgent = 'No';

    public name = '';
    public phoneNumber = '';
    public emailAddress = '';

    public date = '';
    public time = '09:00 AM';
    public alternateDate = '';
    public alternateTime = '09:00 AM';

    public timeOptions = ['09:00 AM', '09:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM', '12:00 PM', '12:30 PM', '01:00 PM', '01:30 PM',
                         '02:00 PM', '02:30 PM', '03:00 PM', '03:30 PM', '04:00 PM', '04:30 PM', '05:00 PM', '05:30 PM', '06:00 PM', '06:30 PM',
                         '07:00 PM', '07:30 PM', '08:00 PM', '08:30 PM', '09:00 PM'];

    public isReponseReceived: boolean = false;

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'showBookViewingDialog') {
            this.onShowDialog();
        }
        if (action.type === 'showRequestSuccess') {
            this.onShowRequestSuccess();
        }
        if (action.type === 'showRequestError') {
            this.onShowRequestError();
        }
    });

    get isMobile(): boolean {
        return (this.$q.screen.width <= this.widthThresholdValue) || (this.$q.screen.height <= this.heightThresholdValue);
    }

    get config() {
        return this.$store.state.config;
    }

    get map() {
        return this.$store.state.map;
    }

    get selectedListingDetail(): ListingDetail {
        return this.$store.state.listings.selectedListingDetail;
    }

    get todaysDate(): string {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const yyyy = today.getFullYear();

        return yyyy + '/' + mm + '/' + dd;
    }

    get currentTime(): string {
        const today = new Date();
        let hours = today.getHours();
        const minutes = today.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        const hoursString = hours < 10 ? '0' + hours : hours;
        const minutesString = minutes < 10 ? '0' + minutes : minutes;
        const strTime = hoursString + ':' + minutesString + ' ' + ampm;
        return strTime;
    }

    get currentDateAndTime(): string {
        return this.todaysDate + ' ' + this.currentTime;
    }

    get allowableTimes(): string[] {
        if (this.date !== this.todaysDate) {
            this.time = this.timeOptions[0];
            return this.timeOptions;
        } else {
            const timeOptionsToReturn = this.todaysAllowableTimes();
            this.time = timeOptionsToReturn[0];
            return timeOptionsToReturn;
        }
    }

    get allowableAlternateTimes(): string[] {
        if (this.alternateDate !== this.todaysDate) {
            this.alternateTime = this.timeOptions[0];
            return this.timeOptions;
        } else {
            const timeOptionsToReturn = this.todaysAllowableTimes();
            this.alternateTime = timeOptionsToReturn[0];
            return timeOptionsToReturn;
        }
    }

    public todaysAllowableTimes() {
        const dateAndTime = this.currentDateAndTime;

        const timeOptionsToReturn = [];

        for (let i = 0; i < this.timeOptions.length; i++) {
            const timeOptionsToCompare = this.todaysDate + ' ' + this.timeOptions[i];

            if (Date.parse(timeOptionsToCompare) > Date.parse(dateAndTime)) {
                timeOptionsToReturn.push(this.timeOptions[i]);
            }
        }

        return timeOptionsToReturn;
    }

    public onShowDialog() {
        this.showDialog = true;
        this.setWrapperHeight();
    }

    public onShowRequestSuccess() {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        window.dataLayer.push({'event': 'showingrequest'});
        this.isReponseReceived = true;
        this.requestSubmittedSuccessfully = true;
    }

    public onShowRequestError() {
        this.isReponseReceived = true;
        this.requestSubmittedSuccessfully = false;
    }

    public mounted() {
        this.isWorkingWithAgent = 'No';
        this.name = '';
        this.phoneNumber = '';
        this.emailAddress = '';

        this.date = this.todaysDate;
        this.alternateDate = this.todaysDate;
        window.onresize = this.setWrapperHeight;
    }

    public onSubmit() {
        const nameValid = (this.$refs.name as Vue & { validate: () => boolean }).validate();
        const phoneNumberValid = (this.$refs.phoneNumber as Vue & { validate: () => boolean }).validate();
        const emailValid = (this.$refs.emailAddress as Vue & { validate: () => boolean }).validate();
        if (nameValid && phoneNumberValid && emailValid) {
            const requestViewingVM = new RequestViewingViewModel(this.selectedListingDetail.MlsNo, this.isWorkingWithAgent, this.name,
                                                 this.phoneNumber, this.emailAddress, this.date, this.time, this.alternateDate, this.alternateTime);
            this.$store.dispatch('initRequestViewing', requestViewingVM);
        }
    }

    public onReset() {
        this.isReponseReceived = false;
        this.isWorkingWithAgent = 'No';
        this.name = '';
        this.phoneNumber = '';
        this.emailAddress = '';

        this.date = this.todaysDate;
        this.alternateDate = this.todaysDate;
    }

    public setWrapperHeight() {
        if (this.isMobile) {
            const height = window.innerHeight - 110;
            this.$nextTick(function() {
                // @ts-ignore
                this.$refs.detailWrapper.$el.style.height = height + 'px';
            });
        }
    }
}

